const SECURITY_CONTEXT_V1_URL = "https://w3id.org/security/v1";
const SECURITY_CONTEXT_V2_URL = "https://w3id.org/security/v2";

module.exports = { SECURITY_CONTEXT_V1_URL, SECURITY_CONTEXT_V2_URL };
